// extracted by mini-css-extract-plugin
export default {"min-and-max":"filters-module__min-and-max--GE0","minAndMax":"filters-module__min-and-max--GE0"};